
import React from "react";

export default function FAQs({ faqs }) {
  const [activeIndex, setActiveIndex] = React.useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <h1
        className="text-4xl font-bold text-center mb-8"
        data-aos="fade-right"
      >
        Have Questions?
      </h1>
      <div className="flex flex-col items-center space-y-4">
        {faqs.map((faq) => (
          <div key={faq.id} className="w-full max-w-2xl" data-aos="fade-left">
            <div
              className="flex justify-between items-center border-b py-4 cursor-pointer"
              onClick={() => toggleAnswer(faq.id)}
            >
              <span className="text-lg">{faq.question}</span>
              <i
                className={`fas fa-chevron-${
                  activeIndex === faq.id ? "up" : "down"
                }`}
              ></i>
            </div>
            {activeIndex === faq.id && (
              <div className="faq-answer transform transition-transform duration-500 ease-in-out">
                <p className="p-4 bg-gray-100 rounded-lg shadow-lg text-gray-700">
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}